<template>
  <div class="detail-dialog">
    <el-dialog :visible.sync="visible" title="明细" class="ui6-bk-dialog" width="650px" @opened="opened" @closed="closed">
      <div>
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
        <el-button type="primary" style="margin:0 12px" @click="searchE()">查询</el-button>
        <span>审核总量:{{listData.length || 0}}条</span>
      </div>
      <div class="table-box">
        <el-table :data="listData">
          <el-table-column type="index" :index="indexMethod" label="序号" width="100"> </el-table-column>
          <el-table-column property="time" label="时间" width="150"></el-table-column>
          <el-table-column property="count" label="审核数量" width="200"></el-table-column>
          <el-table-column property="operaUser" label="操作人员"></el-table-column>
        </el-table>
      </div>
      <!-- <div class="pager-wrap" style="text-align:right;margin:10px 0px;">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          @current-change="queryList"
          :current-page="pagination.page"
          :page-size="pagination.size"
          :total="listData.total"
          prev-text="上一页"
          next-text="下一页"
        >
        </el-pagination>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import api from "../api";
export default {
  name: "DetailDialog",
  components: {},
  data() {
    return {
      timeRange: [],
      visible: false,
      allowSub: true,
      contentText: {},
      rowInfo: {},
      pagination: { page: 1, size: 10 },
      listData: [],
      subForm: {
        startTime: "",
        endTime: ""
      }
    };
  },
  mounted() {},
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    setInfo(info) {
      this.rowInfo = info;
    },
    setVisible(val) {
      this.visible = val;
    },

    queryList(e) {
      this.pagination.page = e;
      this.getListInfo();
    },
    searchE() {
      if (this.timeRange && this.timeRange.length > 1) {
        if (this.timeRange[0]) this.subForm.startTime = this.timeRange[0].getTime();
        if (this.timeRange[1]) this.subForm.endTime = this.timeRange[1].getTime();
      } else {
        this.timeRange = [];
        this.subForm = {
          startTime: "",
          endTime: ""
        };
      }
      this.getListInfo();
    },
    getListInfo() {
      api
        .getStatisticsDetail({
          endTime: this.subForm.endTime,
          startTime: this.subForm.startTime,
          operaUser: this.rowInfo.operaUser
        })
        .then(res => {
          this.listData = res.data;
        });
    },

    opened() {},
    closed() {}
  },
  watch: {
    visible(newValue, oldValue) {
      if (newValue === true) {
        this.getListInfo();
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
